import { useState, useEffect } from 'react';
import { apiService } from '@/services/api';

export interface AutoTransferOption {
  value: string;
  label: string;
}

export interface AutoTransferOptions {
  categories: AutoTransferOption[];
  vehicleTypes: AutoTransferOption[];
  fuelTypes: AutoTransferOption[];
  transmissions: AutoTransferOption[];
  conditions: AutoTransferOption[];
  colors: AutoTransferOption[];
  doors: AutoTransferOption[];
  armorLevels: AutoTransferOption[];
  steeringTypes: AutoTransferOption[];
  characteristics: AutoTransferOption[];
}

export function useAutoTransferOptions() {
  const [options, setOptions] = useState<AutoTransferOptions>({
    categories: [],
    vehicleTypes: [],
    fuelTypes: [],
    transmissions: [],
    conditions: [],
    colors: [],
    doors: [],
    armorLevels: [],
    steeringTypes: [],
    characteristics: [],
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        setLoading(true);
        const data = await apiService.getAllVehicleOptions();

        setOptions({
          categories: Array.isArray(data.categories) ? data.categories : [],
          vehicleTypes: Array.isArray(data.types) ? data.types : [],
          fuelTypes: Array.isArray(data.fuelTypes) ? data.fuelTypes : [],
          transmissions: Array.isArray(data.transmissions) ? data.transmissions : [],
          conditions: Array.isArray(data.conditions) ? data.conditions : [],
          colors: Array.isArray(data.colors) ? data.colors.map(c => ({ value: c.value, label: c.label })) : [],
          doors: Array.isArray(data.doors) ? data.doors.map(d => ({ value: String(d.value), label: d.label })) : [],
          armorLevels: Array.isArray(data.armorLevels) ? data.armorLevels : [],
          steeringTypes: Array.isArray(data.steeringTypes) ? data.steeringTypes : [],
          characteristics: Array.isArray(data.characteristics) ? data.characteristics : [],
        });
      } catch (error) {
        console.error('Failed to fetch auto-transfer options:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchOptions();
  }, []);

  return { options, loading };
}
